export const paths = Object.freeze({
  TERMS: "/terms",
  REASON: "/reason-form",
});
